var module = 'main', name = 'main/components/appointment-additional-info/appointment-additional-info.html', content = "<div class=\"container\"><span class=\"additional-info-icon\"></span> <span class=\"title\" translate=\"home.upcoming.additional_info.title\"></span><div class=\"additional-info\"><span class=\"block-with-text\" multiline-ellipsis=\"::$ctrl.appointment.reminderText\" max-lines=\"3\"></span></div></div>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/components/appointment-additional-info/appointment-additional-info.html
// module id = 1321
// module chunks = 0